import React from 'react';
import { Tag } from 'antd';

export const maintenanceStatusText = {
  OVERDUE: 'Overdue',
  DUE_SOON: 'Due soon',
  UPCOMING: 'Upcoming',
  ON_TRACK: 'On track',
};

export const maintenanceStatusColor = {
  OVERDUE: 'red',
  DUE_SOON: 'orange',
  UPCOMING: 'blue',
  ON_TRACK: 'green',
};

export const serviceStatusText = {
  IN_SERVICE: 'In service',
  DOWN: 'Down',
  WAITING_ON_PARTS: 'Waiting on parts',
  RETIRED: 'Retired',
};

export const serviceStatusColor = {
  IN_SERVICE: 'blue',
  DOWN: 'red',
  WAITING_ON_PARTS: 'gold',
  RETIRED: 'default',
};

export function normalizeMaintStatus(status) {
  const k = String(status || '').trim().toUpperCase();
  return k === 'NEEDS_SETUP' ? 'ON_TRACK' : k;
}

export function MaintenanceStatusTag({ status }) {
  const k = normalizeMaintStatus(status);
  const label = maintenanceStatusText[k];
  const color = maintenanceStatusColor[k] || 'default';
  return label ? <Tag className="maintenance-status-tag" color={color}>{label}</Tag> : '';
}

export function ServiceStatusTag({ status }) {
  if (!status) return '';
  const k = String(status).toUpperCase();
  const label = serviceStatusText[k];
  const color = serviceStatusColor[k] || 'default';
  return label ? <Tag className="maintenance-status-tag" color={color}>{label}</Tag> : '';
}
